// Import Redux
import { AnyAction } from 'redux'
// Import Redux Types
import {
  DOWNLOAD_CURRENT_OFFERING,
  SUCCESS_DOWNLOAD_CURRENT_OFFERING,
  ERROR_DOWNLOAD_CURRENT_OFFERING
  // DOWNLOAD_OFFERINGS_DATA,
  // SUCCESS_DOWNLOAD_OFFERINGS_DATA,
  // ERROR_DOWNLOAD_OFFERINGS_DATA
} from '../types/index'



// State Reducer
const initialState = {
  offerings: [],
  isLoad: false,
  error: false,
  currentOffering: {
    name: 'Temporal name',
    age: 'Temporal age',
    photo: '',
    dedicatedText: 'Temporal text',
    dedicatedBy: 'Temporal dedicated by'
  }
}



// Reducer
export default ( state = initialState, action:AnyAction ) => {
  switch( action.type ) {
    case DOWNLOAD_CURRENT_OFFERING:
      return {
        ...state,
        isLoad: true
      }
    case SUCCESS_DOWNLOAD_CURRENT_OFFERING:
      return {
        ...state,
        isLoad: false,
        error: false,
        currentOffering: action.payload
        // currentOffering: {
        //   ...state.currentOffering,
        //   name: action.payload.honoredname,
        //   age: action.payload.honoreddate,
        //   photo: action.payload.image,
        //   dedicatedText: action.payload.dedicatory,
        //   dedeicatedBy: `${action.payload.firstname} ${action.payload.lastname}`
        // }
      }
    case ERROR_DOWNLOAD_CURRENT_OFFERING:
      return {
        ...state,
        isLoad: false,
        error: true
      }
    default:
      return {
        ...state
      }
  }
}
